import React from "react";
import AIReviewHTMLEditor from "../../../organisms/AIReviewHTMLEditor";
import { Drug, DrugSearchResult } from "../../../../common/models/types";

interface EditModeProps {
  content: string;
  onChange: (content: string) => void;
  onDelete: () => void;
  onReferenceClick?: (referenceId: string) => void;
  promptType?: string;
  isSaving?: boolean;
  hasEditedVersion?: boolean;
  editorRef?: React.RefObject<any>;
  drugsData?: Drug[];
  pillsData?: DrugSearchResult[];
}

const EditMode: React.FC<EditModeProps> = ({
  content,
  onChange,
  onDelete,
  onReferenceClick,
  promptType,
  isSaving = false,
  hasEditedVersion = false,
  editorRef,
  drugsData,
  pillsData,
}) => {
  return (
    <AIReviewHTMLEditor
      ref={editorRef}
      initialContent={content}
      onChange={onChange}
      promptType={promptType}
      onReferenceClick={onReferenceClick}
      onDelete={onDelete}
      hasEditedVersion={hasEditedVersion}
      isSaving={isSaving}
      drugsData={drugsData}
      pillsData={pillsData}
    />
  );
};

export default EditMode;
